import React, { useState, useEffect } from "react";
import axios from "axios";
import UserList from "./userList"; // Import UserList component
import UserForm from "./userform"; // Import UserForm component
import { useUserContext } from "../../context/UserContext";
import SideBar from "../../components/SideBar"; // Assuming you have a SideBar component
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import {
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
} from "@mui/material";
import { toast } from "react-toastify";

const CreateUser = () => {
  const loginUserData = useUserContext();
  const [users, setUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [usersPerPage] = useState(10);
  const [showDialog, setShowDialog] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [filterName, setFilterName] = useState("");
  const [deleteUserId, setDeleteUserId] = useState(null); // Store the user id for deletion confirmation
  const [deleteConfirmationDialog, setDeleteConfirmationDialog] =
    useState(false); // Control delete confirmation dialog visibility

  const API_BASE_URL = process.env.REACT_APP_BASE_URL;

  const fetchUsers = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/User/all`);
      if (response.status === 200) {
        setUsers(response.data.items || []);
        setFilteredUsers(response.data.items || []);
      }
    } catch (err) {
      console.error("An error occurred while fetching users.", err);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  const handleEditUser = (user) => {
    setIsEditing(true);
    setSelectedUser(user);
    setShowDialog(true);
  };

  const handleDeleteUser = async () => {
    if (!deleteUserId) return;
    try {
      const response = await axios.post(
        `${API_BASE_URL}/User/soft_delete/${deleteUserId}`
      );
      if (response.status === 200) {
        toast("User deleted successfully!");
        fetchUsers();
        setDeleteConfirmationDialog(false); // Close the delete confirmation dialog
      }
    } catch (err) {
      toast("Error deleting user.");
      setDeleteConfirmationDialog(false); // Close the dialog in case of error
    }
  };

  const handleAddUser = () => {
    setIsEditing(false);
    setSelectedUser(null);
    setShowDialog(true);
  };

  const handleSubmitUserForm = async (data) => {
    try {
      const url = isEditing
        ? `${API_BASE_URL}/User/form/${selectedUser.id}`
        : `${API_BASE_URL}/User/form`;

      const requestData = {
        ...data,
        created_by: loginUserData.user,
        updated_by: loginUserData.user,
      };

      const response = await axios.post(url, requestData);
      if (response.status === 200) {
        toast(isEditing ? "User updated!" : "User added!");
        fetchUsers();
        setShowDialog(false);
      }
    } catch (err) {
      console.error("Error saving user data.", err);
    }
  };

  const handleFilterChange = (e) => {
    const filterText = e.target.value;
    setFilterName(filterText);
    const filtered = users.filter((user) =>
      user.full_name.toLowerCase().includes(filterText.toLowerCase())
    );
    setFilteredUsers(filtered);
  };

  const handleDeleteConfirmation = (userId) => {
    setDeleteUserId(userId);
    setDeleteConfirmationDialog(true); // Open the confirmation dialog
  };

  return (
    <>
      <SideBar />
      <Header />
      <div className="MainContainer">
        <div className="MenuHeader">
          <div className="CategoryFilter">
            <TextField
              label="Filter by name"
              size="small"
              variant="outlined"
              fullWidth
              value={filterName}
              onChange={handleFilterChange}
            />
          </div>
          <button onClick={handleAddUser}>Add User</button>
        </div>

        <UserList
          fetchUsers={fetchUsers}
          filteredUsers={filteredUsers}
          handleEditUser={handleEditUser}
          handleDeleteUser={handleDeleteConfirmation} // Pass the new delete handler
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          usersPerPage={usersPerPage}
        />

        {showDialog && (
          <UserForm
            open={showDialog}
            handleClose={() => setShowDialog(false)}
            isEditing={isEditing}
            selectedUser={selectedUser}
            onSubmit={handleSubmitUserForm}
            loginUserData={loginUserData}
          />
        )}

        {/* Delete Confirmation Dialog */}
        <Dialog
          open={deleteConfirmationDialog}
          onClose={() => setDeleteConfirmationDialog(false)}
        >
          <DialogTitle>Confirm Deletion</DialogTitle>
          <DialogContent>
            <p>
              Are you sure you want to delete this user? This action cannot be
              undone.
            </p>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => setDeleteConfirmationDialog(false)}
              color="primary"
            >
              Cancel
            </Button>
            <Button
              onClick={handleDeleteUser}
              color="secondary"
              variant="contained"
            >
              Delete
            </Button>
          </DialogActions>
        </Dialog>
      </div>
      <Footer />
    </>
  );
};

export default CreateUser;
